import React, { useState, useEffect } from "react";
import useMediaQuery from "hooks/useMediaQuery";
import { BreakPoints } from "utils/BreakPoints";
import styled from "styled-components";
import amplitude from "amplitude-js";

interface isForm {
  readonly isForm?: boolean;
  readonly isInputText?: boolean;
}
// TODO: change to form?
const InputForm = styled.div<isForm>`
  padding: 1.5rem 2rem 3rem 2rem;

  .required:after {
    content: "*";
    color: red;
  }

  label,
  p {
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    color: #1d2f5d;
  }

  label {
    margin-bottom: 0.5rem;
    line-height: 100%;
    font-size: min(max(13px, 2.3vw), 20px);
  }

  p {
    margin-top: 1.5rem;
    margin-bottom: 3rem;
    font-size: min(max(13px, 2.2vw), 20px);
    margin-left: 1.5rem;
    width: 90%;
  }

  a {
    font-weight: 800;
    color: #1d2f5d;
    text-decoration: none;
  }

  [type="checkbox"]:checked,
  [type="checkbox"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  [type="checkbox"]:checked + label,
  [type="checkbox"]:not(:checked) + label {
    position: relative;
    padding-top: 5px;
    padding-left: 40px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #1d2f5d;
  }

  [type="checkbox"]:checked + label:before,
  [type="checkbox"]:not(:checked) + label:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 28px;
    height: 28px;
    border-radius: 50px;
    border: 1px solid #1d2f5d;
    background: #fff;
  }

  [type="checkbox"]:checked + label:after,
  [type="checkbox"]:not(:checked) + label:after {
    content: "";
    width: 18px;
    height: 18px;
    border-radius: 50px;
    background: #1d2f5d;
    position: absolute;
    top: 6px;
    left: 6px;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  [type="checkbox"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  [type="checkbox"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  input[type="text"],
  input[type="email"],
  input[type="number"] {
    padding: 0.8vh 2vw;
    margin-bottom: 2.5rem;
    background: #ffffff;
    border: 1px solid #1d2f5d;
    box-sizing: border-box;
    border-radius: 50px;
    width: 100%;
    max-height: 50px;
    font-size: min(max(13px, 2.2vw), 20px);

    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    @media (min-width: 768px) {
      padding: 1.2vh 1vw;
      min-width: 300px;
    }

    @media (min-width: 950px) {
      min-width: 32vw;
    }

    @media (min-width: 1366px) {
      padding: 1.5vh 1vw;
      min-width: 420px;
    }

    @media (max-width: 768px) {
      padding: 1vh 1vw;
    }
  }

  @media (max-width: 1366px) {
    padding: 0rem;

    p {
      margin-top: 0rem;
      margin-left: 0rem;
      margin-bottom: 1rem;
      width: 100%;
    }

    input[type="text"],
    input[type="email"],
    input[type="number"] {
      margin-bottom: 1rem;
    }

    [type="checkbox"]:checked + label:before,
    [type="checkbox"]:not(:checked) + label:before {
      width: 58px;
    }

    [type="checkbox"]:checked + label:after,
    [type="checkbox"]:not(:checked) + label:after {
      width: 48px;
    }

    [type="checkbox"]:checked + label,
    [type="checkbox"]:not(:checked) + label {
      padding-left: 67px;
    }
  }

  @media (max-width: 768px) {
    input[type="text"],
    input[type="email"],
    input[type="number"] {
      margin-bottom: 0.6rem;
    }

    [type="checkbox"]:checked + label:before,
    [type="checkbox"]:not(:checked) + label:before {
      margin-left: -5px;
      width: 58px;
    }

    [type="checkbox"]:checked + label:after,
    [type="checkbox"]:not(:checked) + label:after {
      margin-left: -5px;
      width: 48px;
    }

    [type="checkbox"]:checked + label,
    [type="checkbox"]:not(:checked) + label {
      padding-left: 60px;
    }
  }

  @media (max-width: 456px) {
    [type="checkbox"]:checked + label:before,
    [type="checkbox"]:not(:checked) + label:before {
      margin-left: -9px;
      width: 38px;
      height: 20px;
    }

    [type="checkbox"]:checked + label:after,
    [type="checkbox"]:not(:checked) + label:after {
      margin-left: -9px;
      width: 30px;
      height: 14px;
      top: 4px;
      left: 5px;
    }

    [type="checkbox"]:checked + label,
    [type="checkbox"]:not(:checked) + label {
      padding-top: 0px;
      padding-left: 33px;
    }
  }

  @media (max-height: 850px) {
    p {
      margin-bottom: 0rem;
    }
  }

  @media (max-height: 500px) {
    p {
      margin-bottom: 3vh;
    }
  }
`;

const Block = styled.div<isForm>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

const Button = styled.button<isForm>`
  background: #1d2f5d;
  border-radius: 50px;

  font-style: normal;
  font-size: ${(props) =>
    props.isForm ? "min(max(18px, 2vw), 26px)" : "min(max(18px, 2.2vw), 28px)"};
  font-weight: 600;
  line-height: 100%;
  color: #ffffff;
  padding-top: ${(props) =>
    props.isForm ? "clamp(1rem, 1rem, 1rem)" : "clamp(1rem, 1rem, 1rem)"};
  padding-bottom: ${(props) =>
    props.isForm ? "clamp(1rem, 1rem, 1rem)" : "clamp(1rem, 1rem, 1rem)"};
  padding-left: ${(props) =>
    props.isForm ? "clamp(1rem, 3vw, 4vw)" : "clamp(1.5rem, 4vw, 5vw)"};
  padding-right: ${(props) =>
    props.isForm ? "clamp(1rem, 3vw, 4vw)" : "clamp(1.5rem, 4vw, 5vw)"};
  text-align: center;
  border: none;
  margin-left: ${(props) => (props.isInputText ? "5vw" : "0rem")};
  cursor: pointer;
  width: 267px;

  @media (max-width: 1366px) {
    margin-left: ${(props) => (props.isInputText ? "3.5vw" : "0rem")};
    width: ${(props) => props.isForm && "200px"};
    height: ${(props) => props.isForm && "50px"};
    padding: ${(props) => props.isForm && "0px"};
    font-size: ${(props) => props.isForm && "22px"};
  }

  @media (max-width: 900px) and (min-width: 768px) {
    width: ${(props) => props.isForm && "200px"};
  }

  @media (max-width: 768px) {
    margin-top: 5vh;
    margin-left: 0vw;
    max-width: ${(props) => (props.isForm ? "200px" : "267px")};
    width: ${(props) => (props.isForm ? "200px" : "55vw")};
    font-size: ${(props) => props.isForm && "20px"};
  }

  @media (max-height: 500px) {
    margin-top: 5vh;
    font-size: ${(props) => props.isForm && "18px"};
  }
`;

const InputText = styled.input`
  background: #ffffff;
  border: 1px solid #1d2f5d;
  box-sizing: border-box;
  border-radius: 50px;
  padding-top: clamp(1rem, 1rem, 1rem);
  padding-bottom: clamp(1rem, 1rem, 1rem);
  font-weight: 600;
  line-height: 100%;
  font-size: min(max(18px, 2vw), 20px);
  text-align: center;
  width: 267px;

  ::placeholder {
    color: rgba(28, 46, 91, 0.4);
  }

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 768px) {
    margin-top: 5vh;
    max-width: 267px;
    width: 55vw;
    padding-top: clamp(0.8rem, 0.8rem, 0.8rem);
    padding-bottom: clamp(0.8rem, 0.8rem, 0.8rem);
  }

  @media (max-height: 500px) {
    margin-top: 5vh;
  }
`;

// margin-top: 1rem;
// margin-bottom: 1rem;
// input[type="radio"] {
//   transform: scale(2);
//   margin-right: 1.5rem;
//   margin-bottom: 2vh;
//   margin-left: 6vw;
//   cursor: pointer;
// }
// label {
//
//   font-style: normal;
//   font-weight: 600;
//   font-size: min(max(20px, 2vw), 28px);
//   line-height: 100%;
//   letter-spacing: -0.01em;
//   color: #737373;
// }
const InputRadio = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  display: inline;
  margin-left: 3vw;

  input[type="button"] {
    background: #ffffff;
    border: 1px solid #1d2f5d;
    box-sizing: border-box;
    border-radius: 50px;
    width: 25vw;
    max-width: 280px;
    cursor: pointer;
    font-size: min(max(18px, 2vw), 20px);
    color: rgba(28, 46, 91, 0.4);
    padding-top: clamp(1rem, 1rem, 1rem);
    padding-bottom: clamp(1rem, 1rem, 1rem);
    padding-left: clamp(1.5rem, 4.5vw, 5vw);
    padding-right: clamp(1.5rem, 4.5vw, 5vw);
  }

  @media (max-width: 1366px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    display: inline;
    margin-left: 0vw;

    input[type="button"] {
      margin-left: 1rem;
      background: #ffffff;
      border: 1px solid #1d2f5d;
      box-sizing: border-box;
      border-radius: 50px;
      width: 25vw;
      max-width: 250px;
      cursor: pointer;
      font-size: min(max(18px, 2vw), 20px);
      color: rgba(28, 46, 91, 0.4);
      padding-top: clamp(1rem, 1rem, 1rem);
      padding-bottom: clamp(1rem, 1rem, 1rem);
      padding-left: clamp(1.5rem, 4.5vw, 5vw);
      padding-right: clamp(1.5rem, 4.5vw, 5vw);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    display: block;

    input[type="button"] {
      max-width: 267px;
      width: 55vw;
      margin-bottom: 3.5vh;
    }
  }
`;

const ErrorMsg = styled.p`
  display: inline-block;
  color: red;
  margin-top: 2vh;
  margin-right: -5vw;
`;

const ErrorMsgWrap = styled.p`
  display: inline-block;
  color: red;
  margin-top: 2vh;
`;

const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const CenterColumnDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const RadioWrapDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-bottom: 2vh;
  margin-left: -4.5vw;
  margin-top: -10vh;

  @media (max-width: 1366px) {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 0vh;
    margin-left: 0vw;
    margin-top: -6vh;
  }

  @media (max-width: 768px) {
    margin-top: 0vh;
  }
`;

const WrapDiv = styled.div`
  display: flex;

  @media (max-width: 768px) {
    margin-top: 0.7vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @media (max-height: 600px) {
    margin-top: 3vh;
  }
`;

const TabletFormDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 68vw;

  .agreement {
    margin-top: 1rem;
    width: 470px;
  }

  @media (max-width: 900px) {
    flex-wrap: wrap;
    justify-content: center;

    .agreement {
      width: 100%;
    }
  }
`;

const MobileRadioBtn = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 1366px) {
    margin-left: -1rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    margin-right: 0vw;
  }
`;
interface Props {
  type?: string;
  minLength?: number;
  maxLength?: number;
  answer?: object;
  setAnswer?: any;
  buttonText?: string;
  inputText?: string;
  isInputText?: boolean;
  isInputRadio?: boolean;
  radio1?: string;
  radio2?: string;
  radio3?: string;
  radio4?: string;
  question?: string;
  step?: number;
  setStep?: any;
  isInputForm?: boolean;
  isEnding?: boolean;
  radioDisplay?: any;
  onClose?: any;
  stateCheck?: any;
  setStatePass?: any;
  objKey?: string;
  submitForm?: any;
}

const Answer: React.FC<Props> = ({
  type,
  minLength,
  maxLength,
  answer,
  setAnswer,
  buttonText,
  isInputText,
  inputText,
  isInputRadio,
  radio1,
  radio2,
  radio3,
  radio4,
  question,
  step,
  setStep,
  isInputForm,
  isEnding,
  radioDisplay,
  onClose,
  stateCheck,
  setStatePass,
  submitForm,
}) => {
  const FormDataConstant = {
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    agreement: false,
    // option: "",
  };

  const [currentInputText, setCurrentInputText] = useState("");
  const [currentInputRadio, setCurrentInputRadio] = useState("");
  const [formData, setFormData] = useState(FormDataConstant);
  const [formFirstName, setFormFirstName] = useState("");
  const [formLastName, setFormLastName] = useState("");
  const [formEmail, setFormEmail] = useState("");
  const [formNumber, setFormNumber] = useState("");
  const [formAgreement, setFormAgreement] = useState(false);
  // const [formOption, setFormOption] = useState("");
  const [error, setError] = useState(false);
  const isDesktopBreakPoint = useMediaQuery(BreakPoints.DESKTOP_L);
  const isTabletBreakPoint = useMediaQuery(BreakPoints.TABLET_FORM);
  const [isDesktop, setDesktop] = useState(false);
  const [isTablet, setTablet] = useState(false);
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (isDesktopBreakPoint) {
      setDesktop(true);
    } else {
      setDesktop(false);
    }
  }, [isDesktopBreakPoint]);

  useEffect(() => {
    if (isTabletBreakPoint) {
      setTablet(true);
    } else {
      setTablet(false);
    }
  }, [isTabletBreakPoint]);

  const onChangeInputText = (e: any) => {
    setCurrentInputText(e.target.value);
  };

  const onChangeInputRadio = (e: any) => {
    setCurrentInputRadio(e.target.id);
  };

  const onClickInputButton = (e: any, question: any, objKey?: any) => {
    const newData = { ...answer };
    // const data = { Question: "", Answer: "" || {} };
    // data["Question"] = question;
    // data["Answer"] = e.target.id;

    newData[objKey === 3 ? "parent" : objKey === 4 ? "autism" : ""] =
      e.target.id;
    setAnswer(newData);

    let currentStep = step;
    currentStep++;
    setStep(currentStep);
  };

  const onChangeHandler = (info: any, question: any, objKey?: any) => {
    const newData = { ...answer };
    // const data = { Question: "", Answer: "" || {} };
    // const tempFormData = { ...formData };
    let pass = false;

    if (step === 1) {
      const result = stateCheck(currentInputText);
      if (result) {
        setStatePass(true);
      } else {
        setStatePass(false);
      }
    }

    if (info === "number") {
      if (
        currentInputText.trim().length >= minLength &&
        currentInputText.trim().length <= maxLength
      ) {
        newData[objKey === 1 ? "zipCode" : objKey === 2 ? "age" : ""] =
          currentInputText;
        pass = true;
        setError(false);
      } else {
        pass = false;
        setError(true);
      }
    } else if (info === "radio") {
      if (currentInputRadio.trim().length > 0) {
        newData[objKey === 3 ? "parent" : objKey === 4 ? "autism" : ""] =
          currentInputRadio;
        pass = true;
        setError(false);
      } else {
        pass = false;
        setError(true);
      }
    } else if (info === "form") {
      if (
        formFirstName.trim() === "" ||
        formLastName.trim() === "" ||
        formEmail.trim().indexOf("@") === -1 ||
        formNumber.trim() === "" ||
        formNumber.trim().length !== 10
      ) {
        pass = false;
        setError(true);
      } else {
        pass = true;
        setError(false);
        newData["firstName"] = formFirstName;
        newData["lastName"] = formLastName;
        newData["email"] = formEmail;
        newData["number"] = formNumber;
        newData["agreement"] = formAgreement;
        // tempFormData.option = formOption;
        // setFormData(tempFormData);
        submitForm(newData);
      }
    } else if (info === "ending") {
      onClose();
    }

    if (pass) {
      setError(false);

      // if (step === 6) {
      //   newData["question" + step] = tempFormData;
      //   setAnswer(newData);
      // } else {
      //   newData["question" + step] = data;
      //   setAnswer(newData);
      // }

      // newData["question" + step] = data;
      setAnswer(newData);

      let currentStep = step;
      currentStep++;
      setStep(currentStep);

      // const event = "AutismSurveyFormData";
      // amplitude.getInstance().logEvent(event, data);
    } else {
      setError(true);
    }
  };

  const onKeyPressHandler = (e, info: any, question: any, objKey?: any) => {
    if (e.key === "Enter") {
      if (objKey === 1) {
        onChangeHandler(info, question, objKey);
      } else if (objKey === 2) {
        onChangeHandler(info, question, objKey);
      }
    }
  };
  return (
    <Block isForm={step === 5 ? true : false}>
      {isInputText && (
        <div style={{ marginTop: "-12vh" }}>
          <CenterColumnDiv>
            <WrapDiv>
              <InputText
                type={type}
                placeholder={inputText}
                onKeyPress={(e) =>
                  onKeyPressHandler(e, "number", inputText, step)
                }
                onChange={(e) => onChangeInputText(e)}
              />
              <Button
                isInputText={isInputText}
                onClick={(e) => onChangeHandler("number", inputText, step)}
              >
                {buttonText}
              </Button>
            </WrapDiv>
            {error && <ErrorMsgWrap>Please enter a valid value!</ErrorMsgWrap>}
          </CenterColumnDiv>
        </div>
      )}
      {isInputRadio && (
        <CenterColumnDiv>
          <RadioWrapDiv
            style={{
              flexDirection: radioDisplay ? radioDisplay : "row",
            }}
          >
            {/* {!isDesktop ? (
              <>
                {radio1 && (
                  <InputRadio>
                    <input
                      type="radio"
                      id={radio1}
                      name={question}
                      // onChange={(e) => onChangeInputRadio(e)}
                      onClick={(e) => onClickInputButton(e, question, step)}
                    ></input>
                    <label htmlFor={question}>{radio1}</label>
                  </InputRadio>
                )}
                {radio2 && (
                  <InputRadio>
                    <input
                      type="radio"
                      id={radio2}
                      name={question}
                      // onChange={(e) => onChangeInputRadio(e)}
                      onClick={(e) => onClickInputButton(e, question, step)}
                    ></input>
                    <label htmlFor={question}>{radio2}</label>
                  </InputRadio>
                )}
                {radio3 && (
                  <InputRadio>
                    <input
                      type="radio"
                      id={radio3}
                      name={question}
                      // onChange={(e) => onChangeInputRadio(e)}
                      onClick={(e) => onClickInputButton(e, question, step)}
                    ></input>
                    <label htmlFor={question}>{radio3}</label>
                  </InputRadio>
                )}
                {radio4 && (
                  <InputRadio>
                    <input
                      type="radio"
                      id={radio4}
                      name={question}
                      // onChange={(e) => onChangeInputRadio(e)}
                      onClick={(e) => onClickInputButton(e, question, step)}
                    ></input>
                    <label htmlFor={question}>{radio4}</label>
                  </InputRadio>
                )}
              </>
            ) : ( */}
            <MobileRadioBtn>
              {radio1 && (
                <InputRadio>
                  <input
                    type="button"
                    id={radio1}
                    value={radio1}
                    name={question}
                    onClick={(e) => onClickInputButton(e, question, step)}
                  ></input>
                </InputRadio>
              )}
              {radio2 && (
                <InputRadio>
                  <input
                    type="button"
                    id={radio2}
                    value={radio2}
                    name={question}
                    onClick={(e) => onClickInputButton(e, question, step)}
                  ></input>
                </InputRadio>
              )}
              {radio3 && (
                <InputRadio>
                  <input
                    type="button"
                    id={radio3}
                    value={radio3}
                    name={question}
                    onClick={(e) => onClickInputButton(e, question, step)}
                  ></input>
                </InputRadio>
              )}
              {radio4 && (
                <InputRadio>
                  <input
                    type="button"
                    id={radio4}
                    value={radio4}
                    name={question}
                    onClick={(e) => onClickInputButton(e, question, step)}
                  ></input>
                </InputRadio>
              )}
            </MobileRadioBtn>
            {/* )
            } */}
          </RadioWrapDiv>
          {/* {!isDesktop && (
            <Button
              isInputText={isInputText}
              onClick={(e) => onChangeHandler("radio", question, step)}
            >
              {buttonText}
            </Button>
          )}
          {error && <ErrorMsg>Please enter a valid value!</ErrorMsg>} */}
        </CenterColumnDiv>
      )}
      {isInputForm && (
        <InputForm>
          {!isDesktop ? (
            <CenterColumnDiv>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <ColumnDiv>
                  <label className="required" htmlFor="firstName">
                    Parent's first name
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    onChange={(e) => setFormFirstName(e.target.value)}
                  />
                </ColumnDiv>
                <ColumnDiv>
                  <label className="required" htmlFor="lastName">
                    Parent's last name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    onChange={(e) => setFormLastName(e.target.value)}
                  />
                </ColumnDiv>
              </div>
            </CenterColumnDiv>
          ) : isTablet ? (
            <CenterColumnDiv>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <ColumnDiv>
                  <label className="required" htmlFor="firstName">
                    Parent's first name
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    onChange={(e) => setFormFirstName(e.target.value)}
                  />
                </ColumnDiv>
                <ColumnDiv>
                  <label className="required" htmlFor="lastName">
                    Parent's last name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    onChange={(e) => setFormLastName(e.target.value)}
                  />
                </ColumnDiv>
              </div>
            </CenterColumnDiv>
          ) : (
            <div>
              <ColumnDiv>
                <label className="required" htmlFor="firstName">
                  Parent's first name
                </label>
                <input
                  type="text"
                  id="firstName"
                  onChange={(e) => setFormFirstName(e.target.value)}
                />
              </ColumnDiv>
              <ColumnDiv>
                <label className="required" htmlFor="lastName">
                  Parent's last name
                </label>
                <input
                  type="text"
                  id="lastName"
                  onChange={(e) => setFormLastName(e.target.value)}
                />
              </ColumnDiv>
            </div>
          )}
          {isTablet ? (
            <CenterColumnDiv>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <ColumnDiv>
                  <label className="required" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    onChange={(e) => setFormEmail(e.target.value)}
                  />
                </ColumnDiv>
                <ColumnDiv>
                  <label className="required" htmlFor="number">
                    Phone number
                  </label>
                  <input
                    type="number"
                    id="number"
                    placeholder="No Dashes"
                    onChange={(e) =>
                      setFormNumber(e.target.value.replace(/\D[^.]/g, ""))
                    }
                  />
                </ColumnDiv>
              </div>
            </CenterColumnDiv>
          ) : (
            <div>
              <ColumnDiv>
                <label className="required" htmlFor="email">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  onChange={(e) => setFormEmail(e.target.value)}
                />
              </ColumnDiv>
              <ColumnDiv>
                <label className="required" htmlFor="number">
                  Phone number
                </label>
                <input
                  type="number"
                  id="number"
                  placeholder="No Dashes"
                  onChange={(e) =>
                    setFormNumber(e.target.value.replace(/\D[^.]/g, ""))
                  }
                />
              </ColumnDiv>
            </div>
          )}
          {isTablet ? (
            <CenterColumnDiv>
              <TabletFormDiv>
                <ColumnDiv>
                  <div style={{ display: "flex", marginTop: "1rem" }}>
                    <input
                      type="checkbox"
                      name="agreement"
                      id="agreement"
                      onChange={(e) =>
                        setFormAgreement(e.target.id ? true : false)
                      }
                    ></input>
                    <label htmlFor="agreement" style={{ whiteSpace: "nowrap" }}>
                      Send appointment updates to my phone.
                    </label>
                  </div>
                  <div className="agreement">
                    <p>
                      Message and data rates may apply. Reply “STOP” any time to
                      cancel. By clicking Submit, you agree to our{" "}
                      <span>
                        <a href="https://zinniahealth.com/privacy-policy">
                          Privacy Policy
                        </a>
                      </span>
                      .
                    </p>
                  </div>
                </ColumnDiv>
                {/* <ColumnDiv>
                    <label htmlFor="option">
                      How did you learn about Zinnia Autism? (optional)
                    </label>
                    <input
                      type="text"
                      id="option"
                      placeholder="Select Option"
                      onChange={(e) => setFormOption(e.target.value)}
                    />
                  </ColumnDiv> */}
                <Button
                  isForm={step === 5 ? true : false}
                  style={{ marginLeft: "1vw", marginTop: "5vh" }}
                  onClick={(e) => onChangeHandler("form", isInputForm)}
                >
                  {buttonText}
                </Button>
              </TabletFormDiv>
              {error && (
                <div
                  style={{
                    color: "red",
                    position: "relative",
                    marginTop: "2vh",
                    marginBottom: "-2vh",
                  }}
                >
                  Something wrong, please check!
                </div>
              )}
            </CenterColumnDiv>
          ) : (
            <div>
              {" "}
              <ColumnDiv>
                <div style={{ display: "flex", marginTop: "1rem" }}>
                  <input
                    type="checkbox"
                    name="agreement"
                    id="agreement"
                    onChange={(e) =>
                      setFormAgreement(e.target.id ? true : false)
                    }
                  ></input>
                  <label
                    htmlFor="agreement"
                    style={{ marginLeft: "0.5rem", whiteSpace: "nowrap" }}
                  >
                    Send appointment updates to my phone.
                  </label>
                </div>
                <div style={{ marginTop: "1rem" }}>
                  <p>
                    Message and data rates may apply. Reply “STOP” any time to
                    cancel. By clicking Submit, you agree to our{" "}
                    <span>
                      <a href="https://zinniahealth.com/privacy-policy">
                        Privacy Policy
                      </a>
                    </span>
                    .
                  </p>
                </div>
              </ColumnDiv>
              {/* <ColumnDiv>
            <label htmlFor="option">
              How did you learn about Zinnia Autism? (optional)
            </label>
            <input
              type="text"
              id="option"
              placeholder="Select Option"
              onChange={(e) => setFormOption(e.target.value)}
            />
          </ColumnDiv> */}
              <CenterColumnDiv>
                <Button
                  isForm={step === 5 ? true : false}
                  style={{ marginLeft: "0vw", marginTop: "3vh" }}
                  onClick={(e) => onChangeHandler("form", isInputForm)}
                >
                  {buttonText}
                </Button>
                {error && (
                  <span style={{ color: "red" }}>
                    Something wrong, please check!
                  </span>
                )}
              </CenterColumnDiv>
            </div>
          )}
        </InputForm>
      )}
      {isEnding && (
        <div style={{ marginTop: "-1rem", marginBottom: "1rem" }}>
          <Button onClick={(e) => onChangeHandler("ending", isEnding)}>
            {buttonText}
          </Button>
        </div>
      )}
    </Block>
  );
};

export default Answer;
